// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-label {
  font-size: 12px;
}

#vehicle-checker-widget form {
  background-color: var(--widgetBgColour) !important;
  z-index: 999;
  position: sticky;
  top: 0;
}

.switch-label {
  font-size: 0.875rem;
  font-weight: 400;
}

.addVehicleModal .confirm-vrm {
  font-size: 2rem;
  display: inline-block;
  line-height: 2rem;
  padding: 5px 10px;
  border-radius: 8px;
  border: solid 1px #CEB83B;
}
.addVehicleModal div.make-model-deriv {
  padding-right: 10px;
}
.addVehicleModal .make-model {
  font-size: 25px;
  font-weight: bold;
  margin-top: 7px;
}
.addVehicleModal .deriv {
  font-size: 14px;
  font-weight: 400;
  color: #777;
}
.addVehicleModal .confirm-text {
  margin-top: 8px;
  font-weight: 600;
}

.vrm {
  background-color: var(--vrmBackgroundColour) !important;
  font-family: var(--vrmFontFamily);
  font-size: 0.75rem;
  font-weight: bold;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  display: block;
}

table th {
  text-align: center;
}

.vehicle-list .make-model {
  font-weight: 500;
  line-height: 1rem;
}
.vehicle-list .deriv-name {
  font-size: 0.9rem;
}

.fa-times {
  color: var(--dangerColour);
}

.fa-check {
  color: var(--successColour);
}

.row-content {
  text-align: center;
  vertical-align: middle;
}
.row-content .desc {
  font-size: 11px;
  white-space: nowrap;
  overflow-x: hidden;
  max-width: 80px;
  text-overflow: ellipsis;
  margin: 0 auto;
}

.checker-column-1 {
  cursor: pointer;
  background-color: rgb(51, 51, 51);
  color: white;
  font-size: 1.1em;
  text-align: center;
  vertical-align: middle;
}

.stick-column {
  position: sticky;
  left: 0;
  background: white !important;
  z-index: 9;
}

.adStatus {
  font-size: 11px;
  background-color: #e9fdee;
  font-weight: 500;
  line-height: 1rem;
}

.adStatus1 {
  background-color: #E9FDEE;
}

.pagination {
  margin-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/vehicle/vehicle-checker/vehicle-checker.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAIE;EACE,kDAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;AADJ;;AAMA;EACE,mBAAA;EACA,gBAAA;AAHF;;AAQE;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AALJ;AAQE;EACE,mBAAA;AANJ;AASE;EACE,eAAA;EACA,iBAAA;EACA,eAAA;AAPJ;AAUE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AARJ;AAWE;EACE,eAAA;EACA,gBAAA;AATJ;;AAaA;EACE,uDAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAVF;;AAaA;EACE,kBAAA;AAVF;;AAgBE;EACE,gBAAA;EACA,iBAAA;AAbJ;AAgBE;EACE,iBAAA;AAdJ;;AAmBA;EAEE,0BAAA;AAjBF;;AAqBA;EAEE,2BAAA;AAnBF;;AAuBA;EAEE,kBAAA;EACA,sBAAA;AArBF;AAuBE;EAEE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;AAtBJ;;AA2BA;EACE,eAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAxBF;;AA2BA;EAEE,gBAAA;EACA,OAAA;EACA,4BAAA;EACA,UAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAxBF;;AA2BA;EACE,yBAAA;AAxBF;;AA2BA;EACE,2BAAA;AAxBF","sourcesContent":[".side-label {\n  font-size: 12px;\n}\n\n#vehicle-checker-widget {\n\n  form {\n    background-color: var(--widgetBgColour) !important;\n    z-index: 999;\n    position: sticky;\n    top: 0;\n  }\n\n}\n\n.switch-label {\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.addVehicleModal {\n\n  .confirm-vrm {\n    font-size: 2rem;\n    display: inline-block;\n    line-height: 2rem;\n    padding: 5px 10px;\n    border-radius: 8px;\n    border: solid 1px #CEB83B;\n  }\n\n  div.make-model-deriv {\n    padding-right: 10px;\n  }\n\n  .make-model {\n    font-size: 25px;\n    font-weight: bold;\n    margin-top: 7px;\n  }\n\n  .deriv {\n    font-size: 14px;\n    font-weight: 400;\n    color: #777;\n  }\n\n  .confirm-text {\n    margin-top: 8px;\n    font-weight: 600;\n  }\n}\n\n.vrm {\n  background-color: var(--vrmBackgroundColour) !important;\n  font-family: var(--vrmFontFamily);\n  font-size: 0.75rem;\n  font-weight: bold;\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  display: block;\n}\n\ntable th {\n  text-align: center;\n}\n\n.vehicle-list {\n\n\n  .make-model {\n    font-weight: 500;\n    line-height: 1rem;\n  }\n\n  .deriv-name {\n    font-size: 0.9rem;\n  }\n}\n\n\n.fa-times {\n\n  color: var(--dangerColour);\n\n}\n\n.fa-check {\n\n  color: var(--successColour);\n\n}\n\n.row-content {\n\n  text-align: center;\n  vertical-align: middle;\n\n  .desc {\n\n    font-size: 11px;\n    white-space: nowrap;\n    overflow-x: hidden;\n    max-width: 80px;\n    text-overflow: ellipsis;\n    margin: 0 auto;\n\n  }\n}\n\n.checker-column-1 {\n  cursor: pointer;\n  background-color: rgb(51, 51, 51);\n  color: white;\n  font-size: 1.1em;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.stick-column {\n  position: -webkit-sticky;\n  position: sticky;\n  left: 0;\n  background: #ffff !important;\n  z-index: 9;\n}\n\n.adStatus {\n  font-size: 11px;\n  background-color: #e9fdee;\n  font-weight: 500;\n  line-height: 1rem;\n}\n\n.adStatus1 {\n  background-color: #E9FDEE;\n}\n\n.pagination {\n  margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
